import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthorityLandingPage } from './pages/AuthorityLandingPage';
import { ProcessLandingPage } from './pages/ProcessLandingPage';
import { SubmissionFormPage } from './pages/SubmissionFormPage';
import { SuccessPage } from './pages/SuccessPage';
import { StatusCheckPage } from './pages/StatusCheckPage';

function App() {
  return (
    <Routes>
      {/* Authority landing page - shows authority info and process selection */}
      <Route path="/submit/:authorityKeyId" element={<AuthorityLandingPage />} />

      {/* Process landing page - shows specific process info */}
      <Route path="/submit/:authorityKeyId/:processKey" element={<ProcessLandingPage />} />

      {/* Submission form for specific process */}
      <Route path="/submit/:authorityKeyId/:processKey/form" element={<SubmissionFormPage />} />

      {/* Success page after submission */}
      <Route path="/submit/:authorityKeyId/:processKey/success" element={<SuccessPage />} />

      {/* Status check page */}
      <Route path="/status" element={<StatusCheckPage />} />

      {/* Redirect root to 404 info page */}
      <Route
        path="/"
        element={
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100vh',
              textAlign: 'center',
              padding: '2rem',
            }}
          >
            <h1>Antragsmanager</h1>
            <p>
              Um einen Antrag einzureichen, benötigen Sie einen gültigen Link von Ihrer Behörde.
            </p>
          </div>
        }
      />

      {/* Catch-all redirect */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
